import ReportDataTable from "./ReportDataTable";
import { ReportRow } from "../types";

const LowStockReport = ({ rows }: { rows: ReportRow[] }) => (
  <ReportDataTable rows={rows} emptyMessage="No low stock report data found." />
);

export default LowStockReport;
